export  function getFriendlyDealMessage(customerDeal) {
    const { commissionType, rev, cpa, cpl } = customerDeal;
    const parts = [];

    if (commissionType.includes("CPA") && cpa !== undefined) {
        parts.push(`€${cpa} CPA`);
    }
    if (commissionType.includes("CPL") && cpl !== undefined) {
        parts.push(`€${cpl} CPL`);
    }
    if (commissionType.includes("REV") && rev !== undefined) {
        parts.push(`${rev}% REV`);
    }
    if (commissionType.includes("NOTSET")) {
        parts.push(`Not set`);
    }

    // Join all parts with " - " to form the friendly message
    return parts.join(" & ");
}

export function getDealMargin(customerDeal, ourDeal) {
    const { rev: pubRev, cpa: pubCpa, cpl: pubCpl, commissionType: pubCommissionType } = customerDeal;
    const { rev: ourRev, cpa: ourCpa, cpl: ourCpl, commissionType: ourCommissionType } = ourDeal;

    // If our commission type is not set, return 0
    if (ourCommissionType === "NOTSET") {
        return {cpa: 0, rev: 0};
    }
    // Create a key to identify the commission type combination
    const commissionKey = `${pubCommissionType}_${ourCommissionType}`;
    
    switch (commissionKey) {
        // Case 1: both are CPA
        case "CPA_CPA":
            if (ourCpa === 0) return 0;
            return {cpa: cpaMargin(ourCpa, pubCpa)};
            
        // Case 2: both are REV
        case "REV_REV":
            if (ourRev === 0) return 0;
            return {rev: revMargin(ourRev, pubRev)};
            
        // Case 3: pub is CPA, our is CPA plus REV
        case "CPA_REV-CPA":
            if (ourCpa === 0) return 0;
            return {
                cpa: cpaMargin(ourCpa, pubCpa), 
                rev: revMargin(ourRev, 0)
            };
            
        // Case 4: both are REV-CPA
        case "REV-CPA_REV-CPA":
            return {
                cpa: cpaMargin(ourCpa, pubCpa),
                rev: revMargin(ourRev, pubRev)
            };
            
        // Handle CPL cases
        case "CPL_CPL":
            if (ourCpl === 0) return 0;
            return {cpl: cplMargin(ourCpl, pubCpl)};
            
        // Default case: return null if commission types don't match
        default:
            return null;
    }
}

const cpaMargin = (ourCpa, pubCpa) => (ourCpa - pubCpa) / ourCpa * 100;
const revMargin = (ourRev, pubRev) => (ourRev - pubRev) / ourRev * 100;
const cplMargin = (ourCpl, pubCpl) => (ourCpl - pubCpl) / ourCpl * 100;



